import type * as React from 'react';

import { FRAGMENT_ANNOTATION_BODY } from '@gitbook/doc-core';
import { Popover } from '@gitbook/react-uikit';
import type { Inline } from '@gitbook/slate';
import { type EditorContainer, FragmentRenderer } from '@gitbook/slate-react';
import { Icon } from '@gitbook/spine-icons';
import { Button } from '@gitbook/spine-react';

/**
 * Popover to render the annotation.
 */
export function AnnotationPopover(props: {
    node: Inline;
    editor: EditorContainer;
    onClose: () => void;
}): React.ReactElement {
    const { node, editor, onClose } = props;
    const { readOnly } = editor;

    const onPressRemove = () => {
        editor.change((change) => {
            change.unwrapInlineByKey(node.key);
        });
    };

    return (
        <Popover preferredAlignment="start" kind="large">
            <div className="flex flex-col gap-2 whitespace-pre-wrap break-words p-4">
                <FragmentRenderer fragment={FRAGMENT_ANNOTATION_BODY} />
                {readOnly ? null : (
                    <div className="flex gap-2 self-end">
                        <Button
                            size="small"
                            kind="secondary"
                            leadingIcon={Icon.Trashcan}
                            label="Remove annotation"
                            iconOnly
                            onPress={onPressRemove}
                        />
                        <Button
                            size="small"
                            kind="secondary"
                            leadingIcon={Icon.Check}
                            label="Confirm"
                            tooltip={{ label: 'In GitBook, changes are automatically saved!' }}
                            iconOnly
                            onPress={onClose}
                        />
                    </div>
                )}
            </div>
        </Popover>
    );
}
